import React, { useState } from 'react';
import AttendeesSummaryCarousel from '../../components/misc/AttendeesSummaryCarousel.jsx';
import BaseButton from '../form/BaseButton.jsx';
import AfterMeetingStep2 from './AfterMeetingStep2.jsx';

const AfterMeeting = ({ meetingId, calendarMeeting, fieldsParticipants }) => {
    const [showOverlay, setShowOverlay] = useState(false);

    const handleStepTwo = () => {
        setShowOverlay(true);
    };

    return (
        <div className='bg-theme1-gray border-0 border-theme1-cardStroke flex flex-col flex-grow p-6 rounded-4xl w-full'>
            <div className='flex items-center gap-[12px]'>
                <div className='rounded-full bg-theme1-primary w-[36px] h-[36px] flex items-center justify-center text-white text-xl'>
                    1
                </div>
                <div>
                    <h4 className='font-bold text-base'>Step 1</h4>
                    <p className='text-sm text-theme1-title2'>Attendees Review</p>
                </div>
            </div>
            <AttendeesSummaryCarousel
                calendarMeetingId={calendarMeeting?.id}
                items={fieldsParticipants}
                className='mt-10 mb-10'
            />
            <BaseButton className='mt-4 btn-red-outline' textValue='Next' onClick={handleStepTwo} />

            <MemoizedAfterMeetingStep2
                meetingId={meetingId}
                calendarMeeting={calendarMeeting}
                showOverlay={showOverlay}
                calendarMeetingUserNotes={calendarMeeting?.objectives}
            />
        </div>
    );
};

const MemoizedAfterMeetingStep2 = React.memo(AfterMeetingStep2);

export default AfterMeeting;
